import api from 'api';
import DesignTemplate from 'records/DesignTemplate';

export const FOOD_TYPE_DESIGN_TEMPLATES_ASYNC_ACTION_START = 'FOOD_TYPE_DESIGN_TEMPLATES_ASYNC_ACTION_START';
export const FOOD_TYPE_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS = 'FOOD_TYPE_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS';
export const FOOD_TYPE_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR = 'FOOD_TYPE_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR';
export const FOOD_TYPE_DESIGN_TEMPLATES_RESET_STATE = 'DESIGN_TEMPLATES_RESET_STATE';

function foodTypeDesignTemplatesAsyncActionStart() {
  return {
    type: FOOD_TYPE_DESIGN_TEMPLATES_ASYNC_ACTION_START,
  };
}

function foodTypeDesignTemplatesAsyncActionError(error) {
  return {
    type: FOOD_TYPE_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR,
    error,
  };
}

function foodTypeDesignTemplatesAsyncActionSuccess(data) {
  return {
    type: FOOD_TYPE_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS,
    data,
  };
}

export function resetfoodTypeDesignTemplatesState() {
  return {
    type: FOOD_TYPE_DESIGN_TEMPLATES_RESET_STATE,
  };
}

export function getfoodTypeDesignTemplates(designTypeId, designSizeId, foodTypeId, layoutId) {
  return (dispatch, getState) => {
    dispatch(foodTypeDesignTemplatesAsyncActionStart());
    return api.request(
      `design/designtemplates/typeitem?typeId=${ foodTypeId }&designtid=${ designTypeId }&sizeid=${ designSizeId }&layoutId=${layoutId!=undefined?layoutId:-1}`,
      'get',
      null
    )
    .then((data) => {
      dispatch(foodTypeDesignTemplatesAsyncActionSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(foodTypeDesignTemplatesAsyncActionError('Unable to get design templates'));
      throw (err);
    });
  };
}

export function getfoodTypeThemeDesignTemplates(foodTypeId, layoutId) {
  return (dispatch, getState) => {
    dispatch(foodTypeDesignTemplatesAsyncActionStart());
    return api.request(
      `design/designtemplates/typeitem?typeId=${ foodTypeId }&layoutId=${layoutId!=undefined?layoutId:-1}`,
      'get',
      null
    )
    .then((data) => {
      dispatch(foodTypeDesignTemplatesAsyncActionSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(foodTypeDesignTemplatesAsyncActionError('Unable to get design templates'));
      throw (err);
    });
  };
}

export function filterfoodTypeThemeDesignTemplates(designTypeId, designSizeId, foodTypeId, layoutId) {
  return (dispatch, getState) => {
    dispatch(foodTypeDesignTemplatesAsyncActionStart());
    let tmpDesignData = getState().foodTypeDesignTemplates.get('data');
    let filterData = DesignTemplate.getDesignTemplatesByTypeAndSizeId(tmpDesignData, designTypeId, designSizeId);

    let filterLayoutData = filterData;
    if(layoutId!=undefined){
      filterLayoutData=DesignTemplate.getDesignTemplatesByLayoutId(filterData, layoutId);
    }

    if(filterLayoutData.size == 0){
      dispatch(getfoodTypeDesignTemplates(designTypeId, designSizeId, foodTypeId, layoutId));
    } else {
      dispatch(resetfoodTypeDesignTemplatesState());
      dispatch(foodTypeDesignTemplatesAsyncActionSuccess(filterLayoutData));
    }
    return tmpDesignData;
  };
}
